import * as _ from 'lodash'
import { IBusinessObject } from '../PA.Core/PA.Core.IF.BO';
import { IMessageProvider, IProgressProvider, MessageType } from '../PA.Core/PA.Core.IF.Basic';
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from '../PA.Core/Basic/Identity'
import { MessageProvider } from '../PA.Core/Basic/Messages'
import { ProgressProvider } from '../PA.Core/Basic/Progress'
import {
    WB_PPA_ScenarioRow,
    WB_PPA_Scenario_PrdRow,
    WB_UserRow,
    WB_PPA_MarketRow,
    WB_PPA_ModelRow,
    WB_PPA_ProductRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbPPAScenario } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_PPA_Market,
    esWB_PPA_Model,
    esWB_PPA_Product,
    esWB_PPA_Scenario,
    esWB_PPA_Scenario_Prd,
    esWB_User
} from "../PA.Core/PAdbSchema";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";
import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { DateUtils } from "../PA.Core/Basic/Dates"
import {
    IHavePPAModel,
    IHavePPAScenarioCalculator,
    IPPAScenarioCalculator
} from "../PA.PPA.Core/PA.PPAScenario.IF.Aspects"
import { PPAScenarioCalculator } from "../PA.PPA.Services/PPAScenarioCalculator"
import { PPAModelBO } from "./PPAModelBO"

export class PPAScenarioBO
    implements IBusinessObject,
        IHavePPAModel,
        IHavePPAScenarioCalculator {
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_PPAScenario: WB_PPA_ScenarioRow;

    _bIsIdEditable: boolean;

    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({ id: 0, name: 'New Spend Function' });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_PPAScenario = null;
        this._bIsIdEditable = true
        this.IHavePPAModel_init();
        this.IHavePPAScenarioCalculator_init();
    }

    get WB_PPAScenario(): WB_PPA_ScenarioRow {
        return this.drWB_PPAScenario;
    }

    get bIsIdEditable(): boolean {
        return this._bIsIdEditable
    }

    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;
        this.LoadProgressProvider.start("Creating PPA Scenario");
        this._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                const sError = "Unable to determine dbContext for new Scenario";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            // Create record using dbContext
            this.dbContext.createRecordWithKey(esWB_PPA_Scenario)
                .then((newPPAScenarioRow: WB_PPA_ScenarioRow) => {
                    newPPAScenarioRow.setDefaults();
                    self.drWB_PPAScenario = newPPAScenarioRow;
                    self.drWB_PPAScenario.cif.SCENARIO_ID = self.LoadOptions.sId || ''
                    self.drWB_PPAScenario.cif.SCENARIO_NAME = self.LoadOptions.sName || ''
                    self.drWB_PPAScenario.cif.SCENARIO_DATE = DateUtils.convertToSAPBW(new Date())

                    self.drWB_PPAScenario.cif.WB_PPA_MODEL_ID = self.LoadOptions.wbModelId
                    return self.dbContext.find(esWB_PPA_Model, self.drWB_PPAScenario.cif.WB_PPA_MODEL_ID)
                })
                .then((modelRow: WB_PPA_ModelRow) => {
                    self.drWB_PPAScenario.WB_PPAModelRow = modelRow

                    self.drWB_PPAScenario.cif.WB_PPA_MARKET_ID = self.LoadOptions.wbMarketId
                    return self.dbContext.find(esWB_PPA_Market, self.drWB_PPAScenario.cif.WB_PPA_MARKET_ID)
                })
                .then((marketRow: WB_PPA_MarketRow) => {
                    self.drWB_PPAScenario.WB_PPAMarketRow = marketRow

                    return self.dbContext.find(esWB_User, self.drWB_PPAScenario.cif.WB_AUTHUSR_ID_CREATEDBY)
                })
                .then((userRow: WB_UserRow) => {
                    self.drWB_PPAScenario.WB_UserRow = userRow
                    self.dbContext.add(esWB_PPA_Scenario, self.drWB_PPAScenario);
                    self.Identity.setAll(self.WB_PPAScenario.cif.WB_PPA_SCENARIO_ID, self.WB_PPAScenario.cif.SCENARIO_ID, self.WB_PPAScenario.cif.SCENARIO_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_PPAScenario, 'WB_PPA_SCENARIO_ID', 'SCENARIO_ID', 'SCENARIO_NAME');

                    return self.populatePPAScenarioProductsFromModel()
                })
                .then(() => {
                    return self.OnIHavePPAModelLoaded
                })
                .then(() => {
                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._bIsIdEditable = true;
                    self._OnLoadComplete = null;
                    resolve(self);
                })
                .catch((err) => {
                    self.LoadProgressProvider.exception(err);
                    error(err)
                })
        });

        return this._OnLoadComplete;
    }

    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver;
        let recordResolverLoadPromise: Promise<void>;

        self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                const sError = "PPA Scenario already loaded.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            self.LoadOptions = options || {};

            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (self.dbContext == null)
                self.dbContext = new PAdbContext();

            if (this.dbContext == null) {
                const sError = "Unable to determine dbContext for PPA Scenario";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                error(sError);
                return;
            }

            if ('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any>self.LoadOptions).RecordResolver;
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = PPAScenarioBO.createRecordResolver({ dbContext: self.dbContext });
                recordResolverLoadPromise = PPAScenarioBO.setupRecordResolver(recordResolver, [anId])
            }

            recordResolverLoadPromise
                .then(function() {
                    const newPPAScenarioRow: any = recordResolver.get(esWB_PPA_Scenario, anId);

                    if (_.isEmpty(newPPAScenarioRow)) {
                        self._OnLoadComplete = null;
                        self.LoadProgressProvider.exception("Id not found.");
                        resolve(self);
                        return;
                    }

                    self.drWB_PPAScenario = newPPAScenarioRow;
                    self.Identity.setAll(self.WB_PPAScenario.cif.WB_PPA_SCENARIO_ID, self.WB_PPAScenario.cif.SCENARIO_ID, self.WB_PPAScenario.cif.SCENARIO_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_PPAScenario, 'WB_PPA_SCENARIO_ID', 'SCENARIO_ID', 'SCENARIO_NAME');

                    return self.OnIHavePPAModelLoaded
                })
                .then((ignore: any) => {
                    // self._bIsIdEditable = !bExist
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.finish();
                    resolve(self);
                })
                .catch((err: any) => {
                    self._OnLoadComplete = null;
                    self.LoadProgressProvider.exception(err);
                    error(err);
                });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }

    async Validate(options?: any): Promise<IBusinessObject> {

        const self = this;

        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_PPAScenario.cif.SCENARIO_NAME + "(" + self.WB_PPAScenario.cif.SCENARIO_ID + ")");

        // Does no validations yet
        self.ValidateOptions = options || {};
        try {
            if (self.dbContext == undefined) {
                const sError = "Unable to determine dbContext to Validate PPA Scenario Data Source.";
                self.ValidateProgressProvider.exception(sError);
                self.ValidateMessageProvider.addMessage({
                    code: "nodbcontext",
                    type: MessageType.Error,
                    title: sError,
                    description: "",
                    subtitle: "",
                    count: 0
                })
            }

            /*    if (self.drWB_PPAScenario.cif.FUNCTION_DEFN_SRC.replace(" ", "") === "") {
                    const sError = "The java expression cannot be empty";
                    self.ValidateProgressProvider.exception(sError);
                    self.ValidateMessageProvider.addMessage({
                        code: "functionempty",
                        type: MessageType.Error,
                        title: sError,
                        description: "",
                        subtitle: "",
                        count: 0
                    })
                }
           */
            // await ModelPredictorBOValidations.ValidateFields(self)

            self._bIsValidated = self.ValidateMessageProvider.countMessages(MessageType.Error) <= 0;
            self.ValidateProgressProvider.finish();
        } catch (err) {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
            return self;
        }

        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }

    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        const wbPPAScenario = <IwbPPAScenario>self.drWB_PPAScenario;
        try {
            self.SaveProgressProvider.start("Saving " + wbPPAScenario.SCENARIO_NAME + "(" + wbPPAScenario.SCENARIO_ID + ")");
            self._bIsSaved = false;
            self.SaveOptions = options || {};

            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext to Save PPA Scenario";
                self.SaveProgressProvider.exception(sError);
                return
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>;
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext);
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext);
            }


            await self.Validate({})

            if (!self.bIsValidated) {
                self._bIsSaved = false;
                self.SaveProgressProvider.finish();
                return self;
            }

            await saveFunction(esWB_PPA_Scenario, self.drWB_PPAScenario, {})
            const tasks: Promise<any>[] = []
            if (self.WB_PPAScenario.cif.MARKET_IND == '1') {
                const otherScenarios = <WB_PPA_ScenarioRow[]>await self.dbContext.findAll(esWB_PPA_Scenario, {
                    where: {
                        DELETED_IND: { neq: "1" },
                        WB_PPA_MODEL_ID: self.WB_PPAScenario.cif.WB_PPA_MODEL_ID,
                        WB_PPA_MARKET_ID: self.WB_PPAScenario.cif.WB_PPA_MARKET_ID,
                        MARKET_IND: "1",
                        WB_PPA_SCENARIO_ID: { neq: self.WB_PPAScenario.cif.WB_PPA_SCENARIO_ID }
                    }
                })
                _.forEach(otherScenarios, (s) => {
                    s.cif.MARKET_IND = "0"
                })
                if (!_.isEmpty(otherScenarios)) {
                    tasks.push(saveFunction(esWB_PPA_Scenario, otherScenarios))
                }
            }

            tasks.push(saveFunction(esWB_PPA_Scenario_Prd, self.drWB_PPAScenario.WB_PPAScenarioProductRows))
            tasks.push(self.PPAModel.Save())
            await Promise.all(tasks)
            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                })
            } else {
                self._bIsSaved = true;
            }

            self._bIsIdEditable = false
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return (self)
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbPPAScenario = <IwbPPAScenario>self.drWB_PPAScenario;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbPPAScenario.SPEND_FUNCTION_NAME + "(" + wbPPAScenario.SPEND_FUNCTION_ID + ")");

        return new Promise<IBusinessObject>((resolve, error) => {

            // 1. Validate if we can delete the Model Predictor

            // 2. If Valid, mark all the records for deletion.
            self.drWB_PPAScenario.markDeleted();

            if (bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);
                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err);
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }


    Reload(opts?: any): Promise<IBusinessObject> {
        const self = this;

        return new Promise<IBusinessObject>((resolve, error) => {
            if (!self.bIsLoaded) {
                error("Reload: PPA Scenario not loaded");
                return;
            }

            const id = self.WB_PPAScenario.cif.WB_PPA_SCENARIO_ID;

            self.dbContext
                .purgeCache(esWB_PPA_Scenario, self.WB_PPAScenario, {})
                .then((ignore) => {
                    self._bIsLoaded = false;

                    self._OnLoadComplete = undefined;

                    return self.Load(id, { dbContext: self.dbContext });
                })
                .then((aBO) => {
                    if (!aBO.bIsLoaded) {
                        console.log("Unable to Load BO in Reload function");
                    }
                    resolve(self);
                })
                .catch((err) => {
                    error(err);
                });
        });
    }


    addPPAScenarioProduct(): Promise<WB_PPA_Scenario_PrdRow> {
        const self = this;
        return new Promise<WB_PPA_Scenario_PrdRow>((resolve, error) => {
            return self.dbContext.createRecordWithKey(esWB_PPA_Scenario_Prd)
                .then((aNewRow: WB_PPA_Scenario_PrdRow) => {
                    aNewRow.setDefaults();
                    aNewRow.cif.WB_PPA_SCENARIO_ID = self.drWB_PPAScenario.cif.WB_PPA_SCENARIO_ID;
                    aNewRow.WB_PPAScenarioRow = self.drWB_PPAScenario
                    aNewRow.cif.INCLUDE_IND = "1"

                    self.dbContext.add(esWB_PPA_Scenario_Prd, aNewRow);
                    resolve(aNewRow)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removePPAScenarioProduct(aPrdId: number): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            _.forEach(self.drWB_PPAScenario.WB_PPAScenarioProductRows, (x: WB_PPA_Scenario_PrdRow, index: number) => {
                if (x.isActive && x.cif.WB_PPA_SCENARIO_PRD_ID == aPrdId) {
                    x.markDeleted()
                }
            })
            resolve()
        })
    }

    async populatePPAScenarioProductsFromModel(): Promise<void> {
        const self = this;

        const arrProducts: WB_PPA_ProductRow[] = <WB_PPA_ProductRow[]>await self.dbContext.findAll(esWB_PPA_Product, {
            where: {
                DELETED_IND: { neq: "1" },
                WB_PPA_MODEL_ID: self.WB_PPAScenario.cif.WB_PPA_MODEL_ID,
                SCENARIO_PRODUCT_IND: { neq: "1" }
            }
        });
        /*
        const allProductIds = _.map(arrProducts, "WB_PPA_PRODUCT_ID");


        const existingProducts = _.filter(self.WB_PPAScenario.WB_PPAScenarioProductRows, row => row.isActive && row.WB_PPAProductRow.cif.SCENARIO_PRODUCT_IND !== "1")
        const existingProductIds = _.map(existingProducts, "WB_PPA_PRODUCT_ID")

        _.forEach(existingProducts, row => {
            if (row.isActive && !_.includes(allProductIds, row.cif.WB_PPA_PRODUCT_ID)) {
                row.markDeleted();
            }
        })

        arrProducts = _.filter(arrProducts, p => !_.includes(existingProductIds, p.cif.WB_PPA_PRODUCT_ID))
       */
        if (arrProducts) {
            const newIds = await self.dbContext.getNewIds(esWB_PPA_Scenario_Prd, arrProducts.length)
            const newRows: WB_PPA_Scenario_PrdRow[] = []
            for (let idx = 0; idx < arrProducts.length; idx++) {
                const row = arrProducts[idx]
                const newRow: WB_PPA_Scenario_PrdRow = <WB_PPA_Scenario_PrdRow>await self.dbContext.createRecord(esWB_PPA_Scenario_Prd)
                newRow.setDefaults();
                newRow.cif.WB_PPA_SCENARIO_PRD_ID = +newIds[idx]
                newRow.cif.WB_PPA_SCENARIO_ID = self.WB_PPAScenario.cif.WB_PPA_SCENARIO_ID
                newRow.cif.WB_PPA_PRODUCT_ID = row.cif.WB_PPA_PRODUCT_ID;
                newRow.cif.INCLUDE_IND = "1"
                newRow.cif.RETAIL_PRICE = row.cif.RETAIL_PRICE
                newRows.push(newRow)
            }
            await self.dbContext.add(esWB_PPA_Scenario_Prd, newRows)
        }
        return
    }

    //<editor-fold desc="IHaveSimulationCalculator operations">

    private _scenarioCalculator: IPPAScenarioCalculator;

    private IHavePPAScenarioCalculator_init() {
        this._scenarioCalculator = new PPAScenarioCalculator(this);
    }

    private IHavePPAScenarioCalculator_OnLoadComplete(): Promise<void> {
        const self = this;

        return new Promise<void>((resolve, error) => {
            self._scenarioCalculator.Register(self);
            resolve();
        });
    }

    private IHavePPAScenarioCalculator_BeforeReload(): void {
        // Do nothing
    }

    get PPAScenarioCalculator(): IPPAScenarioCalculator {
        return this._scenarioCalculator;
    }

    //<editor-fold desc = "IHavePPAModel operations">
    private _PPAModel: PPAModelBO;
    private _OnIHaveModelLoaded: Promise<void>;
    private _bIHaveModelLoaded: boolean;

    IHavePPAModel_init() {
        this._bIHaveModelLoaded = false;
        this._OnIHaveModelLoaded = undefined;
        this._PPAModel = undefined;
    }

    get bIHavePPAModelLoaded(): boolean {
        return this._bIHaveModelLoaded;
    }

    get OnIHavePPAModelLoaded(): Promise<void> {
        const self = this;

        if (self._OnIHaveModelLoaded) return self._OnIHaveModelLoaded;

        const returnValue = (self._OnIHaveModelLoaded = new Promise<void>((resolve, error) => {
            const wbModelId = self.WB_PPAScenario.cif.WB_PPA_MODEL_ID;
            if (!(wbModelId > 0)) {
                error(`No Model Specified: ${wbModelId}`);
                return;
            }
            const aModel = new PPAModelBO();
            aModel
                .Load(wbModelId, { dbContext: self.dbContext })
                .then((ignore) => {
                    self._PPAModel = aModel;
                    self._bIHaveModelLoaded = true;
                    resolve();
                })
                .catch((err) => {
                    error(err);
                });
        }));

        return returnValue;
    }

    get PPAModel(): PPAModelBO {
        return this._PPAModel;
    }

    //</editor-fold>

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        const opts = boLoadOptions || {};
        let dbContext: PAdbContext;

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }

        const PPAScenario_options: CreateOptions = {
            standardConditions: {
                [esWB_PPA_Scenario]: { DELETED_IND: { notIn: ["1"] } },
                [esWB_PPA_Scenario_Prd]: { DELETED_IND: { notIn: ["1"] } }
            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_PPA_Scenario]: [esWB_PPA_Scenario_Prd]
            }
        };

        const aRecResolver = new ESRecordResolver(dbContext, PPAScenario_options);

        return aRecResolver;
    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_PPA_Scenario, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>
}

PAEnvironment.registerBusinessObjectClass(PPAScenarioBO, "PPAScenarioBO", "PPA Scenario")
